const kpi = {
  title: 'CURRENT STATS', 
};

export default kpi;